import { render, staticRenderFns } from "./Nps.vue?vue&type=template&id=6685d505&scoped=true&lang=pug&"
import script from "./Nps.vue?vue&type=script&lang=js&"
export * from "./Nps.vue?vue&type=script&lang=js&"
import style0 from "./Nps.vue?vue&type=style&index=0&id=6685d505&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6685d505",
  null
  
)

export default component.exports